import React, { useState } from "react";
import Header from "../header/AppHeader";
import ProfileCard from "../profile/ProfileCard";
import background from "../../assets/dashboard-bg.jpg";

const FAQS = [
  {
    q: "How do I earn points?",
    a: "Points come from three sources: completing admin-uploaded tasks, getting your referral registrations verified, and bonus credit for early or exceptional submissions.",
  },
  {
    q: "When are my submitted tasks reviewed and approved?",
    a: 'Coordinators review submissions within 48 hours. Status moves from "In Review" to "Approved" or "Rejected" on your Tasks page, with points credited immediately on approval.',
  },
  {
    q: "What happens if I miss a task deadline?",
    a: "A missed deadline locks that task's points. Many tasks reopen for late submission at reduced credit — reach out to your coordinator before the deadline passes if you need an extension.",
  },
  {
    q: "How is my CA tier (Bronze / Silver / Gold) calculated?",
    a: "Your tier is based on total points: Bronze starts at 0, Silver at 1,000, and Gold at 2,000 points. Tiers update live on your dashboard as your points grow.",
  },
  {
    q: "How do referral points get credited?",
    a: "Referral points are credited automatically once a registration made through your unique link or code is verified by the team. Duplicate, fake, or self-referred entries are not counted.",
  },
  {
    q: "Can I switch tasks or request a custom assignment?",
    a: "Yes — message the coordinator team from the Contact page to swap a task or request a custom assignment. Approvals depend on current campaign needs.",
  },
];

const Faq = () => {
  const [openIndexes, setOpenIndexes] = useState([0, 1]);

  const toggle = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <div
      className="min-h-[100dvh] w-full overflow-x-hidden lg:h-screen lg:w-screen lg:overflow-hidden bg-center bg-cover bg-no-repeat text-[#2B1B17] font-['Montserrat',sans-serif] antialiased flex flex-col"
      style={{ backgroundImage: `url(${background})` }}
    >
      <Header activeTab="FAQ" />

      {/* --- HERO SECTION --- */}
      <section className="px-6 md:px-12 pt-6 pb-5 max-w-[1600px] mx-auto w-full flex-shrink-0">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 relative z-10">

          <div className="text-white flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-black tracking-tight drop-shadow-sm font-['Barlow',sans-serif]">
              FAQ
            </h1>
            <p className="text-sm md:text-base text-white/90 leading-relaxed font-normal drop-shadow-sm sm:max-w-[40rem]">
              Common questions about points, tasks, rewards, and how the CA program works.
            </p>
          </div>

          {/* PROFILE CARD */}
          <ProfileCard />

        </div>
      </section>

      {/* --- FAQ PANEL --- */}
      <main className="max-w-[1600px] mx-auto px-2 md:px-2 w-full relative z-20 overflow-y-auto lg:flex-1 lg:min-h-0 pb-2 flex flex-col">
        <div className="bg-[#F5EFEB]/90 backdrop-blur-md rounded-2xl p-6 md:p-8 shadow-xl border border-white/20 flex flex-col lg:flex-1 lg:min-h-0 lg:overflow-hidden">

          <div className="mb-2 pb-4 border-b border-black/5 flex-shrink-0">
            <h2 className="text-sm font-black tracking-widest text-[#2B1B17]/60 uppercase font-['Barlow',sans-serif]">Frequently Asked Questions</h2>
            <p className="text-xs text-black/40 font-medium mt-0.5">Spirit 2026 · still stuck? message us on the Contact page</p>
          </div>

          <div className="max-h-[60vh] overflow-y-auto lg:max-h-none lg:flex-1 lg:min-h-0 divide-y divide-black/[0.06]">
            {FAQS.map((item, index) => {
              const isOpen = openIndexes.includes(index);
              return (
                <div key={item.q} className="py-5">
                  <button
                    onClick={() => toggle(index)}
                    className="w-full flex items-center justify-between gap-4 text-left"
                  >
                    <span className="font-bold text-[#2B1B17] font-['Barlow',sans-serif]">{item.q}</span>
                    <span className="text-xl font-light text-black/40 flex-shrink-0 leading-none">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>
                  {isOpen && (
                    <p className="text-sm text-black/55 leading-relaxed mt-2 pr-8">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>

        </div>
      </main>
    </div>
  );
};

export default Faq;